import { DefaultMarkerIcon } from "@App/Components/atoms/map/markerIcons/DefaultMarkerIcon";
import { MeinAutoLogo } from "@App/Components/atoms/whitelabel/logos/MeinAutoLogo";
import { RepareoLogo } from "@App/Components/atoms/whitelabel/logos/RepareoLogo";
import { config as defaultConfig } from "@App/configs/default";
import type { Config } from "@App/configs/interfaces";
import { ServiceIsVehicleReturn } from "@App/utils/conditionals/services";
import { differenceInBusinessDays } from "date-fns";

/**
 * Configuration for the Mein Auto whitelabel.
 * Extends the default configuration with specific settings for Mein Auto.
 */
export const config: Partial<Config> = {
  slug: "meinauto",
  navbar: {
    logos: {
      right: {
        component: <MeinAutoLogo />,
      },
      left: {
        component: <RepareoLogo />,
      },
    },
    backToPartnerButton: {
      url: "https://www.meinauto.de/",
    },
  },
  reviews: {
    show: true,
  },
  garageList: {
    // merge with default
    ...defaultConfig.garageList,
    disableFetchLocationOnLoad: true,
  },
  map: {
    MarkerIcon: DefaultMarkerIcon,
    markerContent: "earliestSlot",
  },
  dayPicker: {
    isExtraCostDay: (date, contractEnd) => {
      const workingDaysDiff = differenceInBusinessDays(contractEnd, date);
      return workingDaysDiff >= 5;
    },
    showExtraCostDayInLegend: (service) => ServiceIsVehicleReturn(service),
  },
};

export default config;
